import React, { useState, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { Typography, Popover, Link } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import { usePurchaseHistoryContext } from '../../hooks/useContexts';
import { pushEventInfo } from '../../utils/analytics';

export const MissingPurchase = () => {
  const {
    orderHistoryLoaded,
    orderHistoryData,
    setOpenAddReceiptDrawer,
    customerType,
  } = usePurchaseHistoryContext();
  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const navigate = useNavigate();

  const totalNumberOfOrders =
    orderHistoryData?.orderCount || orderHistoryData?.itemsCount || 0;

  const getTooltipMessage = () => {
    if (customerType === 'b2b') {
      return (
        <Typography variant="body-base">
          Only purchases made with a registered card or added in-store receipts
          will show in Purchase History. Add a registered card to your{' '}
          <Link onClick={() => navigate('/myaccount/payments')}>
            Cards & Accounts
          </Link>
          , or{' '}
          <Link onClick={() => setOpenAddReceiptDrawer(true)}>
            Add a Receipt
          </Link>{' '}
          to see in-store purchases.
        </Typography>
      );
    }
    return (
      <Typography variant="body-base">
        Only purchases made with a registered card will show in Purchase
        History. Add a registered card to your{' '}
        <Link onClick={() => navigate('/myaccount/payments')}>
          Cards & Accounts
        </Link>
        .
      </Typography>
    );
  };

  if (
    orderHistoryLoaded &&
    (totalNumberOfOrders !== 0 || orderHistoryData?.orders?.length !== 0)
  ) {
    return (
      <div className="sui-flex sui-gap-[7px]">
        <Typography>Don&apos;t see a purchase?</Typography>
        <InfoFilled
          style={{ marginTop: '4px', cursor: 'pointer' }}
          size="small"
          color="info"
          aria-describedby={id}
          onClick={(event: { currentTarget: SetStateAction<null> }) => {
            pushEventInfo({
              category: { primaryCategory: 'button submission' },
              eventInfo: { eventName: 'my account settings' },
              myAccount: {
                settings: 'purchase history: dont see a purchase tooltip',
              },
            });
            setAnchorEl(event.currentTarget);
          }}
        />
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={() => setAnchorEl(null)}
          placement="bottom"
          title="Missing Purchases"
          offset="loose"
        >
          <div className="sui-w-[252px]">{getTooltipMessage()}</div>
        </Popover>
      </div>
    );
  }
  return null;
};
